import React, { useEffect } from 'react';
import styled from 'styled-components';

import NavigationBar from '@components/navigation-bar';

import { SensorRemoteControl } from './components/SensorRemoteControl';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import { useNavigate } from 'react-router-dom';

const SensorRemoteControlContainer = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
`;

const SensorRemoteControlPage = () => {
  const { workbenchMode } = useInitialInfoStore();
  const navigate = useNavigate();
  useEffect(() => {
    if (workbenchMode) {
      navigate('/home'); // Redirect to home if workbench mode is enabled
    }
  }, [workbenchMode, navigate]);

  return (
    <SensorRemoteControlContainer>
      <NavigationBar />
      <SensorRemoteControl />
    </SensorRemoteControlContainer>
  );
};

export default SensorRemoteControlPage;
